import {
  GET_POLICY_LIST_FAIL,
  GET_POLICY_LIST_SUCCESS,
  DELETE_POLICY_FAIL,
  DELETE_POLICY_SUCCESS,
  UPLOAD_POLICY_DOC_FAIL,
  UPLOAD_POLICY_DOC_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  res: [],
  error: [],
};

const PrivacyPolicyReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DELETE_POLICY_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case DELETE_POLICY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_POLICY_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };

    case GET_POLICY_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPLOAD_POLICY_DOC_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case UPLOAD_POLICY_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default PrivacyPolicyReducer;
